var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tile",
    { staticClass: "executory", attrs: { link: "executory" } },
    [
      _c(
        "tile-title",
        {
          attrs: { slot: "tileHeader", icon: "hand-o-up" },
          slot: "tileHeader",
        },
        [_vm._v("Исполнительные производства")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "executory__content",
          attrs: { slot: "tileContent" },
          slot: "tileContent",
        },
        [
          _c(
            "app-transition",
            {
              attrs: {
                showLeftIf: _vm.years.length > 0 && _vm.contentType === "table",
                showRightIf: _vm.contentType === "chart",
              },
            },
            [
              _vm.stat
                ? _c("executory-table", {
                    ref: "tableRef",
                    attrs: {
                      slot: "left",
                      years: _vm.sorted_years,
                      stat: _vm.stat,
                    },
                    slot: "left",
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.contentType === "chart"
                ? _c("executory-chart", {
                    attrs: {
                      slot: "right",
                      years: _vm.sorted_years.slice().reverse(),
                      stat: _vm.stat,
                    },
                    slot: "right",
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isModal
            ? _c("executory-modal", {
                attrs: {
                  companyName: _vm.companyName,
                  title: _vm.title,
                  stat: _vm.stat,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "executory__footer",
          attrs: { slot: "tileFooter" },
          slot: "tileFooter",
        },
        [
          _c(
            "app-switcher",
            {
              attrs: {
                leftClickHandler: _vm.changeType,
                rightClickHandler: _vm.changeType,
              },
            },
            [
              _c("span", { attrs: { slot: "leftValue" }, slot: "leftValue" }, [
                _vm._v("Таблица"),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { attrs: { slot: "rightValue" }, slot: "rightValue" },
                [_vm._v("График")]
              ),
            ]
          ),
          _vm._v(" "),
          _c("tile-print-pdf", {
            attrs: {
              html: _vm.htmlContent,
              title: _vm.title,
              printStyle: _vm.printStyle,
              filename: "Executory",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }